import Box from "@mui/material/Box";
// import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
// import Typography from "@mui/material/Typography";
import type * as React from "react";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";

import type { QueryField, QueryResults } from "../types";

export interface QueryReportProps {
	/** Query results data */
	results: QueryResults;
	/** Query fields for parameter display */
	queryFields?: QueryField[];
}

export function QueryReport({
	results,
	// queryFields = [],
}: QueryReportProps): React.JSX.Element {
	// const formatFilterValue = (field: QueryField, value: any): string => {
	// 	if (!value) return "Any";

	// 	switch (field.type) {
	// 		case "text": {
	// 			if (Array.isArray(value) && value.length > 0) {
	// 				return value.join(", ");
	// 			}
	// 			return "Any";
	// 		}
	// 		case "numeric": {
	// 			if (Array.isArray(value) && value.length === 2) {
	// 				return `${value[0]} - ${value[1]}`;
	// 			}
	// 			return "Any";
	// 		}
	// 		case "date": {
	// 			if (
	// 				value &&
	// 				typeof value === "object" &&
	// 				(value.startDate ?? value.endDate)
	// 			) {
	// 				const start = value.startDate ?? "Any";
	// 				const end = value.endDate ?? "Any";
	// 				return `${start} to ${end}`;
	// 			}
	// 			return "Any";
	// 		}
	// 		default: {
	// 			return "Any";
	// 		}
	// 	}
	// };

	return (
		<Stack spacing={3}>
			{/* Query Parameters */}
			{/*<Box>
				<Typography
					variant="subtitle1"
					sx={{ mb: 2, fontWeight: "medium" }}>
					Query Parameters
				</Typography>

				<Stack spacing={1.5}>
					{queryFields.map((field) => {
						// Get the filter value that was applied for this field
						// This would come from the query state that generated the results
						const appliedValue = "Any"; // Placeholder - in real implementation this would come from query state
						const formattedValue = formatFilterValue(field, appliedValue);

						return (
							<Box key={field.id}>
								<Stack
									direction="row"
									justifyContent="space-between"
									alignItems="center">
									<Typography
										variant="body2"
										sx={{ fontWeight: "medium" }}>
										{field.displayName}
									</Typography>
									<Typography
										variant="body2"
										color="text.secondary">
										{formattedValue}
									</Typography>
								</Stack>
							</Box>
						);
					})}
				</Stack>
			</Box>*/}

			{/* Report Content */}
			{results.report && results.report.enabled && (
				<>
					{/*<Divider />*/}
					{/*<Box>*/}
					{/*<Typography
							variant="subtitle1"
							sx={{ mb: 2, fontWeight: "medium" }}>
							Analysis Report
						</Typography>

						{results.report.summary && (
							<Box sx={{ mb: 2 }}>
								<Typography
									variant="body2"
									sx={{ fontStyle: "italic", mb: 1 }}>
									Summary:
								</Typography>
								<Typography
									variant="body2"
									color="text.secondary">
									{results.report.summary}
								</Typography>
							</Box>
						)}*/}

					{!!results.report.content && (
						<RichTextRenderer contents={results.report.content} />
					)}
					{/*</Box>*/}
				</>
			)}

			{/* Spatial Extent Information */}
			{/*{results.metadata.spatialExtent && (
				<>
					<Divider />
					<Box>
						<Typography
							variant="subtitle1"
							sx={{ mb: 2, fontWeight: "medium" }}>
							Spatial Extent
						</Typography>
						<Stack spacing={1}>
							<Stack
								direction="row"
								justifyContent="space-between">
								<Typography variant="body2">Bounds:</Typography>
								<Typography
									variant="body2"
									color="text.secondary">
									{results.metadata.spatialExtent.minX.toFixed(6)},{" "}
									{results.metadata.spatialExtent.minY.toFixed(6)}
									{" → "}
									{results.metadata.spatialExtent.maxX.toFixed(6)},{" "}
									{results.metadata.spatialExtent.maxY.toFixed(6)}
								</Typography>
							</Stack>
						</Stack>
					</Box>
				</>
			)}*/}
		</Stack>
	);
}

// To further customize custom components rendering, see:
// packages/ui-components/src/components/atoms/rich-text-view/index.tsx
export const RichTextRenderer: React.FC<{ contents: string }> = ({
	contents,
}) => {
	return (
		<Box
			sx={{
				"& p": { mb: 1 },
				"& ul": { pl: 2, mb: 1 },
				"& li": { mb: 0.5 },
				"& h1, & h2, & h3, & h4, & h5, & h6": {
					fontWeight: "medium",
					mb: 1,
					mt: 2,
					"&:first-of-type": { mt: 0 },
				},
			}}>
			<Markdown rehypePlugins={[rehypeRaw]}>{contents}</Markdown>
		</Box>
	);
};
